import React from "react";
import { Label } from "./label";
import { cn } from "@/lib/utils";

function IconSlider({ label, value, onChange, ticks, icons, className }) {
  return (
    <div className={cn("space-y-3 w-full", className)}>
      <Label className="text-sm">{label}</Label>
      <div className="relative h-3 w-full rounded-soft bg-rose-50">
        <div
          className="absolute h-3 rounded-soft bg-rose-100 transition-all"
          style={{ width: `${(value / (ticks.length - 1)) * 100}%` }}
          aria-hidden
        />
      </div>
      <div
        role="radiogroup"
        aria-label={label}
        className="grid gap-2"
        style={{ gridTemplateColumns: `repeat(${Math.max(ticks.length, 1)}, minmax(0, 1fr))` }}
      >
        {ticks.map((t, i) => {
          const ActiveIcon = icons[i];
          const isActive = i === value;
          return (
            <button
              key={t}
              role="radio"
              aria-checked={isActive}
              onClick={() => onChange(i)}
              className={cn(
                "flex items-center justify-center gap-2 rounded-soft border px-3 py-2 transition-all",
                isActive
                  ? "bg-orange-100 border-orange-200 text-orange-900 shadow"
                  : "bg-white border-neutral-200 hover:border-orange-300"
              )}
            >
              {ActiveIcon && <ActiveIcon className="h-5 w-5" />}
              <span className="text-sm">{t}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export { IconSlider };
